import React, { useEffect, useState } from 'react';
// import io from 'socket.io-client';
// import { device_URI } from '../../../constants/defaultValues';
import ModalIcon from '../../Icon/Icon';
import CloseButton from '../../CloseButton/CloseButton';
import Title from '../../Title/Title';
import Device from './Device/Device';
import { getTranslation } from '../../../../../utils/translation';
import InfoMessage from '../../InfoMessage/InfoMessage';
import Button from '../../Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { changeAllDevicesModalProps } from '../../../../../store/actions/modals';
import LocalStorage from '../../../../../utils/localStorage';
import io from 'socket.io-client';
import { device_URI } from '../../../../../constants/defaultValues';
import { changeDeviceStatus } from '../../../../../store/actions/global';

const Devices = props => {
    const dispatch = useDispatch();

    const status = useSelector(state => state.global.deviceStatus);

    const closeAllDevicesModal = () => {
        if (!status.isOnline) return;
        dispatch(changeAllDevicesModalProps({ isVisible: false }));
    };

    useEffect(() => {
        window.addEventListener('online', () => handleConnectionChange(true));
        window.addEventListener('offline', () => handleConnectionChange(false));
    }, []);

    const handleConnectionChange = isOnline => {
        dispatch(
            changeDeviceStatus({
                isOnline,
            })
        );
        if (isOnline) {
            window.location.reload();
        } else {
            dispatch(changeAllDevicesModalProps({ isVisible: true }));
        }
    };

    return (
        <>
            <CloseButton onClick={closeAllDevicesModal} />
            <ModalIcon iconKey='status' />
            <Title>{getTranslation('allDevicesModalTitle')}</Title>
            <InfoMessage width='272px'>{getTranslation('allDevicesModalDescription')}</InfoMessage>
            <div className={'m-t-12'}>
                <Device
                    icon='icon-internet'
                    name={getTranslation('allDevicesModalInternetConnection')}
                    status={status.isOnline}
                />
                <Device
                    icon='icon-printer'
                    name={getTranslation('allDevicesModalPrinter')}
                    status={status.printer}
                />
                <Device
                    icon='icon-barcode'
                    name={getTranslation('allDevicesModalScanner')}
                    status={status.scanner}
                />
            </div>
            <Button
                width='183px'
                onClick={closeAllDevicesModal}
                spacing='2px'
                autoMargin
                title={getTranslation('allDevicesModalDone')}
            />
        </>
    );
};

export default Devices;
